import { useState } from 'react';

import SearchDropdown from './SearchDropdown';
import { useGetGroups } from '../../../groups/hooks';

function formatOrganizationOption(data) {
  return { ...data, label: data?.name, photo: { url: data?.badgeImageUrl } };
}

const OrganizationsSearch = ({
  onChange,
  label,
  field,
  placeholder,
  selectedUsers = [],
  ...selectProps
}) => {
  const [searchText, setSearchText] = useState('');
  const { data, isLoading } = useGetGroups({
    role: ['admin', 'owner']
  });

  const onSelectChange = (selected) => {
    onChange(selected);
    setSearchText('');
  };

  return (
    <SearchDropdown
      id={`${field}-dropdown`}
      data={data?.items}
      isLoading={isLoading}
      label={label}
      noOptionsMessage={() => 'No organizations found'}
      onChange={onSelectChange}
      onInputChange={setSearchText}
      optionDataFormatter={formatOrganizationOption}
      placeholder={placeholder}
      selectedUsers={selectedUsers}
      value={searchText}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...selectProps}
    />
  );
};

export default OrganizationsSearch;
